// src/hooks/currencies/useForceDeleteAllCurrencies.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllCurrencies } from "../../api/apiCurrencies";
import { useTranslation } from "react-i18next";

function useForceDeleteAllCurrencies() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: forceDeleteAllCurrenciesMutation, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllCurrencies,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["currencies"] });
            toast.success(isArabic ? "تم حذف العملات المحددة نهائياً" : "Selected currencies permanently deleted");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في الحذف النهائي" : "Failed to force delete currencies"));
        },
    });

    return { forceDeleteAllCurrencies: forceDeleteAllCurrenciesMutation, isForceDeleteAll };
}

export default useForceDeleteAllCurrencies;
